import { useLocation } from "react-router-dom";

const WHATSAPP_NUMBER = "17587230202"; // +1 758 723 0202 (digits only)
const WHATSAPP_MESSAGE = "Hi ProToCall, I'd like to ask about your services.";

export default function WhatsAppButton() {
  const location = useLocation();

  // Don't show on admin routes
  if (location.pathname.startsWith("/admin")) {
    return null;
  }

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_MESSAGE
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with ProToCall on WhatsApp"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-5 right-5 z-[10000] w-[182px] flex items-center justify-center gap-2.5 rounded-xl bg-[#25D366] hover:bg-[#1ebe57] py-3 shadow-xl transition-colors"
    >
      <span className="relative flex h-8 w-8 items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/30 animate-ping"></span>
        <svg
          viewBox="0 0 32 32"
          className="relative w-8 h-8 text-white"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.973 2.722.973.444 0 2.392-.5 2.392-1.518 0-.143-.014-.286-.057-.43-.13-.43-1.275-.974-1.69-1.16-.31-.144-.46-.207-.602-.207zm-3.165 8.84c-1.7 0-3.397-.45-4.894-1.305l-3.508.918.937-3.43A9.5 9.5 0 0 1 6.41 16.79c0-5.234 4.293-9.498 9.535-9.498A9.514 9.514 0 0 1 23 16.79c0 5.249-4.265 9.255-9.055 9.255zm0-20.788c-6.314 0-11.45 5.078-11.45 11.32 0 1.99.53 3.94 1.53 5.66l-1.71 6.236 6.4-1.676a11.55 11.55 0 0 0 5.23 1.246c6.314 0 11.45-5.078 11.45-11.32 0-3.05-1.19-5.91-3.36-8.06a11.43 11.43 0 0 0-8.09-3.406z" />
        </svg>
      </span>
      <span className="flex flex-col leading-tight text-white">
        <span className="text-sm font-bold">Chat with us</span>
        <span className="text-[11px] font-medium opacity-90">on WhatsApp</span>
      </span>
    </a>
  );
}
